import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule} from '@spartacus/core';
import {IconButtonTooltipComponent} from './icon-button-tooltip.component';

@NgModule({
  declarations: [IconButtonTooltipComponent],
  imports: [CommonModule, I18nModule],
  exports: [IconButtonTooltipComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IconButtonTooltipModule {}
